import { createSlice } from "@reduxjs/toolkit";
import {
  getVendorProcessFee,
  getVendorProcessFeeDetailReport,
  getVendorProcessFeePaymentReport,
  updateVendorProcessFeePayment,
} from "./actions/vendorProcessFeeAction.js";

const initialState = {
  vendorProcessingFee: null,
  totalByVendorProcessingFee: 0,
  vendorProcessFeeFilters: {},
  vendorProcessFeePageState: { page: 1, pageSize: 50 },

  vendorProcessingFeeDetailReport: null,
  totalByVendorProcessingFeeDetailReport: 0,
  vendorProcessFeeDetailReportFilters: {},
  vendorProcessFeeReportPageState: { page: 1, pageSize: 50 },

  vendorProcessingFeePaymentReport: null,
  totalByVendorProcessingFeePaymentReport: 0,
  vendorProcessFeePaymentReportFilters: {},
  vendorProcessFeePaymentReportPageState: { page: 1, pageSize: 50 },
};

export const vendorProcessingFeeSlice = createSlice({
  name: "processingfee",
  initialState,
  reducers: {
    setVendorProcessFeeFilters: (state, action) => {
      const { payload } = action;
      state.vendorProcessFeeFilters = payload || {};
    },
    resetVendorProcessFeeFilters: (state) => {
      state.vendorProcessFeeFilters = {};
    },
    setVendorProcessFeePage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.vendorProcessFeePageState = {
          ...state.vendorProcessFeePageState,
          page,
        };
      }
      if (pageSize) {
        state.vendorProcessFeePageState = {
          ...state.vendorProcessFeePageState,
          pageSize,
        };
      }
    },

    setVendorProcessFeeDetailReportFilters: (state, action) => {
      const { payload } = action;
      state.vendorProcessFeeDetailReportFilters = payload || {};
    },
    resetVendorProcessFeeDetailReportFilters: (state) => {
      state.vendorProcessFeeDetailReportFilters = {};
    },
    setVendorProcessFeeReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.vendorProcessFeeReportPageState = {
          ...state.vendorProcessFeeReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.vendorProcessFeeReportPageState = {
          ...state.vendorProcessFeeReportPageState,
          pageSize,
        };
      }
    },

    setVendorProcessFeePaymentReportFilters: (state, action) => {
      const { payload } = action;
      state.vendorProcessFeePaymentReportFilters = payload || {};
    },
    resetVendorProcessFeePaymentReportFilters: (state) => {
      state.vendorProcessFeePaymentReportFilters = {};
    },
    setVendorPayReportPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.vendorProcessFeePaymentReportPageState = {
          ...state.vendorProcessFeePaymentReportPageState,
          page,
        };
      }
      if (pageSize) {
        state.vendorProcessFeePaymentReportPageState = {
          ...state.vendorProcessFeePaymentReportPageState,
          pageSize,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateVendorProcessFeePayment.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateVendorProcessFeePayment.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.vendorProcessingFee = data;
        state.totalByVendorProcessingFee = count;
      })
      .addCase(updateVendorProcessFeePayment.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getVendorProcessFee.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVendorProcessFee.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.vendorProcessingFee = data;
        state.totalByVendorProcessingFee = count;
      })
      .addCase(getVendorProcessFee.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getVendorProcessFeeDetailReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVendorProcessFeeDetailReport.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.vendorProcessingFeeDetailReport = data;
        state.totalByVendorProcessingFeeDetailReport = count;
      })
      .addCase(getVendorProcessFeeDetailReport.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getVendorProcessFeePaymentReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVendorProcessFeePaymentReport.fulfilled, (state, action) => {
        const { data, count, user } = action.payload;
        state.loading = false;
        state.vendorProcessingFeePaymentReport = data;
        if (user) {
          sessionStorage.setItem("vendorPaymentUsers", JSON.stringify(user));
        }
        state.totalByVendorProcessingFeePaymentReport = count;
      })
      .addCase(getVendorProcessFeePaymentReport.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const {
  resetVendorProcessFeeFilters,
  setVendorProcessFeeFilters,
  setVendorProcessFeePage,

  resetVendorProcessFeeDetailReportFilters,
  setVendorProcessFeeDetailReportFilters,
  setVendorProcessFeeReportPage,

  resetVendorProcessFeePaymentReportFilters,
  setVendorProcessFeePaymentReportFilters,
  setVendorPayReportPage,
} = vendorProcessingFeeSlice.actions;

export default vendorProcessingFeeSlice.reducer;
